export default __webpack_public_path__ + "static/media/successImg.130942d6.svg";